import { useSelector } from "react-redux";
import { RootState } from "../state/reducers";
import { useEffect } from "react";

export const useAuth = () => {
    const { user_info } = useSelector((x: RootState) => x.auth);
    useEffect(() => {
        console.log({
            user_info
        });

    }, [user_info])
    return {
        user_info
    };
}
